import PropTypes from 'prop-types';
import React, { Component } from 'react';
import $ from 'jquery';
import moment from 'moment-timezone';
import classnames from 'classnames';
import config from '../../../../config';
import { dateToISO } from '../../../common/helpers/times';
import IncrementalSwitcher from '../incrementalSwitcher/incrementalSwitcher';
import Icon, { GLYPHS } from '../../../common/icon';
import { t } from '../../../../modules/infra/i18n';
import { getCurrentLanguageCode } from '../../../../modules/infra/i18n/language-selection-utils/utils';

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = { opened: false };
  }

  componentDidMount() {
    const $picker = $(this.datepicker);
    const { startDate } = this.props;
    $picker.datepicker({
      autoclose: true,
      format: config.dateFormatISO.toLowerCase(),
      todayHighlight: true,
      startDate,
      language: getCurrentLanguageCode(),
    }).on('changeDate', (e) => {
      this.props.changeDate(dateToISO(e.date));
    }).on('hide', this.unsetOpened);
  }

  componentDidUpdate() {
    $(this.datepicker).datepicker('update', this.props.currentDate);
  }

  onCalendarClick = () => {
    const { opened } = this.state;

    if (opened) this.closeCalendar();

    this.setState({ opened: !opened });
  };

  setToday = (e) => {
    e.preventDefault();
    this.props.changeDate(this.props.today);
  };

  getDateView() {
    const { currentView, currentDate } = this.props;
    const date = moment(currentDate);
    switch (currentView) {
      case 'agendaWeek': {
        const startDay = date.startOf('week').format('DD');
        const startMonth = date.startOf('week').format('MMM');
        const endDay = date.endOf('week').format('DD');
        const endMonth = date.endOf('week').format('MMM');
        const displayEndDate = (startMonth !== endMonth ? `${endMonth} ${endDay}` : endDay);
        return `${startMonth} ${startDay} - ${displayEndDate}`;
      }
      case 'month': {
        const month = date.format('MMM');
        const end = date.endOf('month').format('DD');
        return `${month} 01 - ${end}`;
      }
      default: {
        return date.format('ddd MMMM Do YYYY');
      }
    }
  }

  closeCalendar() {
    $(this.datepicker).datepicker('hide');
  }

  unsetOpened = () => {
    this.setState({ opened: false });
  };

  render() {
    const { currentView, currentDate, timezone } = this.props;
    const buttonClassName = classnames('c-btn c-btn--outline c-btn--medium u-ph--', { 'is-active': this.state.opened });

    return (
      <div className="o-flexbox">
        <div
          className="o-flexbox__item c-heading c-heading--light c-heading--large u-mr"
          data-automation-id="text:header:selectedDate"
        >
          {this.getDateView()}
        </div>
        <div className="o-flexbox c-form-input-group">
          <div className="o-flexbox__item c-form-input-group__item">
            <button
              className={buttonClassName}
              ref={(el) => { this.datepicker = el; }}
              onClick={this.onCalendarClick}
              data-automation-id="button:openDatePicker"
            >
              <Icon glyph={GLYPHS.calendar} size="calendar" />
            </button>
          </div>
          <div className="o-flexbox__item c-form-input-group__item">
            <button
              className="c-btn c-btn--outline c-btn--medium"
              onClick={this.setToday}
              data-automation-id="button:today"
            >
              {t('appointment:date_picker.today')}
            </button>
          </div>
          <IncrementalSwitcher
            changeDate={this.props.changeDate}
            currentView={currentView}
            currentDate={currentDate}
            timezone={timezone}
            startDate={this.props.startDate}
          />
        </div>
      </div>
    );
  }
}

DatePicker.propTypes = {
  changeDate: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  currentDate: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  today: PropTypes.string.isRequired,
};

export default DatePicker;
